<template>
	<div id="sidebar" class="" v-bind:class="{ openSidebar: openSidebar }">
		<div id="toggleSidebar" :class="openSidebar ? 'rightArrow' : 'centeredArrow'" @click="toggleSidebar">
      <span :class="openSidebar ? 'icon-collapse-arrow' : 'icon-expand-arrow'"></span>
    </div>
		<ul>
      <li :class="{'active': subIsActive('/dashboard')}">
        <router-link class="flex" to="/dashboard">
          <div class="sidebarIcon"><span class="icon-dashboard"></span></div>
          <div v-if="openSidebar" class="sidebarText">{{ $t("sidebar.dashboard") }}</div>
        </router-link>
      </li>
			<li :class="{'active': subIsActive('/recipient')}">
				<router-link class="flex" to="/recipient">
					<div class="sidebarIcon"><span class="icon-recipient"></span></div>
					<div v-if="openSidebar" class="sidebarText">{{ $t("sidebar.recipient") }}</div>
				</router-link>
			</li>
      <li :class="{'active': subIsActive('/config')}" v-if="globalStore.user.role === 'Admin'">
        <router-link class="flex" to="/config">
          <div class="sidebarIcon"><span class="icon-settings"></span></div>
          <div v-if="openSidebar" class="sidebarText">{{ $t("sidebar.configuration") }}</div>
        </router-link>
      </li>
		</ul>
		<ul id="personalSidebar">
      <li>
        <a class="flex justify-center items-center" :href="`mailto:${globalStore.settings.systemConfig?.contactPerson}`">
          <div class="pseudoContactButton tooltip">
            <div class="tooltiptext">{{globalStore.settings.systemConfig?.contactPerson}}</div>
            <div class="contactIcon"><span class="icon-contact"></span></div>
            <span v-if="openSidebar" class="sidebarText pl-1">{{ $t("sidebar.contactPerson") }}</span>
          </div>
        </a>
      </li>
			<li class="myAccount">
				<router-link class="flex" to="/account">
					<Avatar/>
					<a href="#" v-if="openSidebar" class="sidebarText pl-3">
            <span>{{ globalStore.user?.firstName ?? "" }} {{ globalStore.user?.lastName ?? "" }}</span>
          </a>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script setup>
import Avatar from "@/components/Avatar";
import { useGlobalStore } from '@/stores/GlobalStore'
import {ref} from "vue";
import {useRoute} from "vue-router";

let openSidebar = ref(true);
const globalStore = useGlobalStore();

const toggleSidebar = () => {
	openSidebar.value = !openSidebar.value
}

const subIsActive = (input) => {
	const paths = Array.isArray(input) ? input : [input];
	const route = useRoute();
	return paths.some(path => {
		return route.path.indexOf(path) === 0 // current path starts with this path string
	})
}
</script>

<style lang="scss">
	#sidebar {
		@apply flex flex-col;
		overflow-y: auto;
		overflow-x: hidden;
		background: $lightGrey;
		height: 100vh;
		top: 0;
		position: sticky;
		.sidebarText {
			display: flex;
			align-items: center;
		}
    a.sidebarText, span.sidebarText{
      @apply flex-1 overflow-y-auto break-words;
      color: $ogeTextBlue;
      font-size: 14px !important;
      font-family: 'Gotham-Light', sans-serif !important;
    }
		ul li {
			@apply h-12 pr-2 pl-2 flex items-center text-left;
			font-size: 17px;
      font-family: 'Gotham-Medium', sans-serif !important;
			color: $ogeTextBlue;
			a {
				font-weight: normal;
				line-height: 17px;
				div {
					line-height: 24px;
				}
			}
		}
		.sidebarIcon {
			@apply pr-4 justify-center align-middle;
			position: relative;
			font-size: 36px;
			text-align: center;
			width: 36px;
      height: 36px;
		}
		.notificationCount {
			@apply rounded-3xl;
			position: absolute;
			top: -5px;
			right: 5px;
			width: 15px;
			height: 15px;
			font-size: 10px;
			text-align: center;
			background: red;
			color: #fff;
			line-height: 15px;
		}
		.active {
			border-left: 3px solid $ogeMagenta;
			color: $ogeMagenta;
      .sidebarText {
        color: $ogeMagenta;
      }
		}
	}
	#personalSidebar {
		@apply mt-auto;
		background: $lightGrey;
		.myAccount {
			@apply flex pb-8 pt-8;
			background: $lightGrey;
			color: $white;
		}
	}
	#toggleSidebar {
		@apply p-4 pl-0 mb-[2.4rem];
		color: $ogeMagenta;
		&:hover {
			cursor: pointer;
		}
	}
  .centeredArrow{
    @apply ml-4;
    text-align: center;
    font-size: 17px;
  }
  .rightArrow{
    text-align: right;
    font-size: 17px;
  }
	.openSidebar {
		width: 200px;
	}
  div.pseudoContactButton{
    @apply flex p-1 pl-2 pr-4  mb-8;
    background-color: $white;
    border: 1px solid $white;
    border-radius: 1.4rem;
    .contactIcon{
      @apply justify-center align-middle;
      position: relative;
      font-size: 24px;
      text-align: center;
      width: 24px;
      height: 24px;
    }
  }
</style>
